const Validation = {
  isRequired: (obj) => {
    let messages = [];

    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      

      if (value === null || value === "" || value === undefined || (typeof value === "string" && value.trim() === "")) {
        messages.push(`${key} is required`);
      }
    });

    return {
      isValid: messages.length === 0, // True if no errors, false if there are errors
      message: messages.join(", ") // Combine all messages into a single string
    };
  },
  isPolicyRequired: (obj, option) => {
    
    let messages = [];

    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (value === null || value === "" || value === undefined || (typeof value === "string" && value.trim() === "")) {
        if (key === "cpr" && option !== "General Payment") {
          return; // Skip validation for 'cpr' in other cases
        }
        if (key === "Plate") {
          return; // Skip validation for 'cpr' in other cases
        }
        if (key === "Quote" && option === "General Payment") {
          return; // Skip validation for 'cpr' in other cases
        }
        if (key === "ProductName" && option === "General Payment") {
          return; // Skip validation for 'cpr' in other cases
        }
        if (key === "Make") {
          return; // Skip validation for 'cpr' in other cases
        }
        if (key === "Model") {
          return; // Skip validation for 'cpr' in other cases
        }
        messages.push(`${key} is required`);
      }
    });

    return {
      isPolicyDetailsValid: messages.length === 0, // True if no errors, false if there are errors
      PolicyMessage: messages.join(", ") // Combine all messages into a single string
    };
  },
  isEmail: (value, message = "Invalid email format") => {
    
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(value)) {
      return { isEmailValid: false, EmailMessage: message };
    }
    return { isEmailValid: true, EmailMessage: "" };
  },

  minLength: (value, minLength = 6) => {
    if (value.length < minLength) {
      return { isValid: false, error: `Must be at least ${minLength} characters` };
    }
    return { isValid: true, error: "" };
  },

  PhoneNumberValid: (value, length = 8) => {

  if (!value || value.length !== length) {
    return { isPhoneValid: false, PhoneMessage: `Phone number must be ${length} characters` };
  }
  return { isPhoneValid: true, PhoneMessage: "" };
},

  RequestLimitValid: (value) => {
    
  const limit = parseInt(sessionStorage.getItem('requestLimit'), 10);

  if (isNaN(limit)) {
    return {
      isRequestLimitValid: false,
      RequestLimitMessage: "Request limit is not set correctly in session."
    };
  }

  const numericValue = parseFloat(value);

  if (isNaN(numericValue)) {
    return {
      isRequestLimitValid: false,
      RequestLimitMessage: "Value is not a valid number."
    };
  }

  if (numericValue > limit) {
    return {
      isRequestLimitValid: false,
      RequestLimitMessage: `Your limit is ${limit}`
    };
  }

  return {
    isRequestLimitValid: true,
    RequestLimitMessage: ""
  };
}

};

export default Validation;
